import PropTypes from 'prop-types';
import { BsCheckCircle, BsEnvelope, BsPeople } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';

export const StatCard = ({ title, value, icon: Icon, iconColor, bgColor }) => (
	<Card className="py-5">
		<div className="flex items-center gap-3">
			<div className={`p-2 rounded-card ${bgColor}`}>
				<Icon className={`h-4 w-4 ${iconColor}`} />
			</div>
			<div>
				<p className="text-xs text-bgBase-800">{title}</p>
				<p className="text-lg font-bold">{value}</p>
			</div>
		</div>
	</Card>
);

StatCard.propTypes = {
	title: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	icon: PropTypes.elementType.isRequired,
	iconColor: PropTypes.string.isRequired,
	bgColor: PropTypes.string.isRequired,
};

const CampaignStatsCards = ({ statistics, loading, emailCount = 0, recipientCount = 0, campaignType }) => {
	const { sentCount = 0 } = statistics || {};

	const isAiCampaign = campaignType === 'ai_personalized';

	if (loading) {
		return (
			<div className={`grid grid-cols-2 ${isAiCampaign ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-4`}>
				{[1, 2, 3].map((i) => (
					<div key={i} className="animate-pulse">
						<Card className="h-24 bg-bgBase-400" />
					</div>
				))}
			</div>
		);
	}

	return (
		<div className={`grid grid-cols-2 ${isAiCampaign ? 'md:grid-cols-2' : 'md:grid-cols-3'} gap-4`}>
			{!isAiCampaign && (
				<StatCard
					title="E-Mails"
					value={emailCount}
					icon={BsEnvelope}
					iconColor="text-primary-600"
					bgColor="bg-primary-100"
				/>
			)}
			<StatCard
				title="Empfänger"
				value={recipientCount}
				icon={BsPeople}
				iconColor="text-primary-700"
				bgColor="bg-primary-200"
			/>
			<StatCard
				title="Gesendet"
				value={sentCount}
				icon={BsCheckCircle}
				iconColor="text-success-700"
				bgColor="bg-success-200"
			/>
		</div>
	);
};

CampaignStatsCards.propTypes = {
	statistics: PropTypes.shape({
		sentCount: PropTypes.number,
	}),
	loading: PropTypes.bool,
	emailCount: PropTypes.number,
	recipientCount: PropTypes.number,
	campaignType: PropTypes.string,
};

export default CampaignStatsCards;
